// Bump whenever the backend's public dialogue, discussion, or default-vocab JSON changes.
export const PUBLIC_CONTENT_CACHE_VERSION = '2026-09-03-1';
